// extracted by mini-css-extract-plugin
export default {"main":"ServiceDetail_main__kmr+m","mainContent":"ServiceDetail_mainContent__egWMf","navigation":"ServiceDetail_navigation__4-5aC","way":"ServiceDetail_way__kil2q"};